export default {
    IS_NOT_EMPTY: 'Отсутствует обязательные данные',
    IS_EMAIL: 'Неверный формат email',
    MIN_LENGTH_6: 'Минимум 6 символов',
    MIN_LENGTH_3: 'Введите минимум 3 символа',
    IS_MOBILE_PHONE: 'Номер телефона недействителен',
    CONTAINS_facebook: 'URL Facebook недействителен',
    CONTAINS_instagram: 'URL Instagram недействителен',
    CONTAINS_linkedin: 'URL LinkedIn недействителен',
    CONTAINS_twitter: 'URL Twitter недействителен',
    CONTAINS_tiktok: 'URL Tik Tok недействителен',
    CONTAINS_review: 'URL Google недействителен',
    IS_NUMBER_STRING: 'Недопустимое значение',
    INVALID_PIB: 'Недействительный PIB',
    IS_POSITIVE: 'Число должно быть положительным',
    IS_DATE_STRING: 'Неверный формат даты',
    IS_PHONE_NUMBER: 'Номер телефона в формате с кодом страны (+38164123123)',
    MAXIMUM_100: 'Вы превысили максимальное количество символов - 100',
    MAXIMUM_255: 'Вы превысили максимальное количество символов - 255',
    MAXIMUM_600: 'Вы превысили максимальное количество символов - 600',
    MAXIMUM_1: 'Число должно быть между 1 и 100',
    MINIMUM_0: 'Число должно быть больше 0',
    MINIMUM_15: 'Число должно быть больше 15',
    MAXIMUM_180: 'Число должно быть меньше 180',
    IS_ARRAY: 'Вы должны выбрать хотя бы один вариант',
    OFFER: {
        EXPIRED: 'Эта услуга истекла.',
        NOT_FOUND: 'Эта услуга не найдена.',
    },
    DISCOUNT: {
        ALREADY_ACTIVE_DISCOUNT_FOR_OFFER_CATEGORY: 'Для этого диапазона времени уже существует скидка для данной категории',
    },
    AVAILABILITY: {
        TO_IS_SAME_OR_BEFORE_FROM: `'Дата окончания' должна быть после 'Дата начала'.`,
        DIFFERENT_TIMEZONE: `Эта доступность находится в другом часовом поясе. Пожалуйста, создайте новую доступность`,
    },
    LOCATION: {
        DIFFERENT_TIMEZONE: `Изменение адреса местоположения доступно только в том же часовом поясе.`,
    },
    USER: {
        TAKEN_EMAIL: 'Этот адрес электронной почты уже занят',
        EMAIL_BAD_FORMAT: 'Неверный формат email',
        EMAIL_NOT_VERIFIED: 'Пожалуйста, сначала подтвердите свой email',
        BAD_CREDENTIALS: 'Неверные учетные данные',
        INVALID_OLD_PASSWORD: 'Неверный старый пароль',
        RESEND_LIMIT_REACHED: 'Достигнут лимит повторной отправки SMS',
        INVALID_CHANGE_MOBILE_TOKEN: 'Неверный код подтверждения',
        ALREADY_PART_OF_THE_COMPANY: 'Клиент уже существует в компании!',
        HAS_ACTIVE_COMPANY: 'Невозможно удалить профиль с активной компанией.',
    },
    COMPANY: {
        NAME_EXIST: 'Название компании уже существует',
        PIB_EXIST: 'PIB уже существует',
        SUBDOMAIN_NOT_ALLOWED: 'Недопустимое имя субдомена!',
        SUBDOMAIN_EXISTS: 'Имя субдомена уже существует',
    },
    RATING: {
        ALREADY_RATED: 'Услуга уже оценена',
        TOKEN_EXPIRED: 'Время для оценки истекло!',
    },
}
